




import { Component, Prop, Vue } from "vue-property-decorator";

declare global {
  interface Window {
    turnstile?: {
      render: (
        container: string | HTMLElement,
        options: {
          sitekey: string;
          callback: (token: string) => void;
          "expired-callback": () => void;
          "error-callback": () => void;
        }
      ) => string;
      reset: (widgetId?: string) => void;
    };
  }
}

@Component
export default class TurnstileWidget extends Vue {
  @Prop({ required: true }) private siteKey!: string;

  private widgetId = "";

  private mounted() {
    this.loadTurnstile();
  }

  public reset() {
    this.$emit("expired");
    if (window.turnstile && this.widgetId) {
      window.turnstile.reset(this.widgetId);
    }
  }

  private loadTurnstile() {
    if (window.turnstile) {
      this.renderTurnstile();
      return;
    }

    const existingScript = document.querySelector(
      'script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]'
    );
    if (existingScript) {
      existingScript.addEventListener("load", this.renderTurnstile);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", this.renderTurnstile);
    document.head.appendChild(script);
  }

  private renderTurnstile() {
    if (!window.turnstile || this.widgetId) {
      return;
    }

    const container = this.$refs.turnstileWidget as HTMLElement | undefined;
    if (!container) {
      return;
    }

    this.widgetId = window.turnstile.render(container, {
      sitekey: this.siteKey,
      callback: (token: string) => {
        this.$emit("verified", token);
      },
      "expired-callback": () => {
        this.$emit("expired");
      },
      "error-callback": () => {
        this.$emit("error");
      },
    });
  }
}
